import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-keep-warranty',
    templateUrl: './keep-warranty.component.html',
    styleUrls: ['./keep-warranty.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepWarrantyComponent {

}
